import SpecItem from "./specItem.component";
import GetTicketsBtn from "./getTicketsBtn/getTicketsBtn.component";
export { SpecItem, GetTicketsBtn };